import(/* webpackMode: "eager" */ "/app/app/swap/page.tsx");
